import React from "react";

const ICON_PATHS = {
  search: "M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm5 12 4 4",
  grid: "M4 4h7v7H4V4Zm9 0h7v7h-7V4ZM4 13h7v7H4v-7Zm9 0h7v7h-7v-7Z",
  list: "M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01",
  phone: "M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z",
  mail: "M3 6h18v12H3V6Zm0 1 9 7 9-7",
  pin: "M12 21s7-6.2 7-11.5A7 7 0 0 0 5 9.5C5 14.8 12 21 12 21Zm0-8.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
  image: "M4 5h16v14H4V5Zm0 11 4-4 3 3 3-4 6 6M9 9.5h.01",
  chat: "M4 5h16v11H9l-5 4V5Z",
  chart: "M5 20V10m5 10V4m5 16v-7m5 7V8",
  share: "M12 4v12m0-12-4 4m4-4 4 4M5 14v6h14v-6",
  star: "M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.9L12 17l-5.2 2.7 1-5.9L3.5 9.7l5.9-.8L12 3.5Z",
  external: "M14 4h6v6m0-6-9 9M18 14v6H4V6h6",
  edit: "M4 20h4L19 9l-4-4L4 16v4Zm9-13 4 4",
  alert: "M12 3 2.5 20h19L12 3Zm0 6v5m0 3h.01",
  calendar: "M4 6h16v14H4V6Zm0 4h16M8 3v4m8-4v4",
  folder: "M3 7a1 1 0 0 1 1-1h5l2 2h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7Z",
  dollar: "M12 3v18m4-14H10a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6H7",
  check: "M5 12.5 10 17.5 19 7",
  clock: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 4v4.5l3 2",
  users: "M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-6 8a6 6 0 0 1 12 0M17 11a2.5 2.5 0 1 0 0-5M16.5 19a5 5 0 0 0-2-4",
  doc: "M7 3h7l4 4v14H7V3Zm7 0v4h4M10 12h5m-5 4h5",
  funnel: "M3 5h18l-7 8v6l-4-2v-4L3 5Z",
  bars: "M5 20V10m5 10V4m5 16v-7m5 7V8",
  wallet: "M4 7h15a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12M16 13h.01",
  pulse: "M3 12h4l2-6 4 12 2-6h6",
  bolt: "M13 3 5 13h6l-1 8 8-10h-6l1-8Z",
  plus: "M12 5v14M5 12h14",
  user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 8a7 7 0 0 1 14 0",
  box: "M4 8 12 4l8 4v8l-8 4-8-4V8Zm0 0 8 4m0 0 8-4m-8 4v8",
  spark: "M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z",
  play: "M8 5v14l11-7L8 5Z",
  arrow: "M5 12h14m-5-5 5 5-5 5",
  sun: "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0-6v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5M17.5 17.5 19 19M5 19l1.5-1.5M17.5 6.5 19 5",
  moon: "M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z",
  help: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-2.5 6.5a2.5 2.5 0 1 1 3.5 2.3c-.7.4-1 .9-1 1.7M12 17h.01",
  cog: "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0-6 1.5 2.4 2.8-.6.6 2.8L19.6 9 18 11.5l1.6 2.5-2.7 1.4-.6 2.8-2.8-.6L12 20l-1.5-2.4-2.8.6-.6-2.8L4.4 14 6 11.5 4.4 9l2.7-1.4.6-2.8 2.8.6L12 3Z",
};

export function CmdIcon({ name, className = "" }) {
  return (
    <svg viewBox="0 0 24 24" className={`cmd-icon ${className}`.trim()} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={ICON_PATHS[name] || ICON_PATHS.pulse} />
    </svg>
  );
}
